(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    // Keep the cart + header count bubble in sync (CartDrawer.buildCart listens for this).
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

    // SPQR 2026-06-27: transient "Added ✓" feedback on the add-to-cart buttons
    // (primary buy button + sticky summary bar) instead of auto-opening the cart drawer.
    document.querySelectorAll('[data-atc-button], [data-summary-atc]').forEach((btn) => {
      // Don't skip disabled buttons: product-form briefly disables the primary button
      // during submit, and submit:success only fires for in-stock items anyway.
      // Swap the label text directly (the theme's .element-button uses ::after itself,
      // so a CSS pseudo-element overlay isn't reliable here).
      var labelEl = btn.querySelector('.element-text') || btn;
      if (btn._spqrOrigLabel == null) btn._spqrOrigLabel = labelEl.textContent;
      labelEl.textContent = '✓ Added';
      btn.classList.add('is-added');
      clearTimeout(btn._spqrAddedTimer);
      btn._spqrAddedTimer = setTimeout(function () {
        btn.classList.remove('is-added');
        labelEl.textContent = btn._spqrOrigLabel;
        btn._spqrOrigLabel = null;
      }, 1500);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
